import * as Sentry from '@sentry/angular';
import { ErrorHandler, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SentryErrorHandler implements ErrorHandler {

  handleError(error: any) {
    Sentry.captureException(error.originalError ?? error);
  }

  updateSentryUser(id, email, first_name) {
    Sentry.setUser({
      id: id,
      email: email,
      username: first_name
    });
  }

}
